// extracted by mini-css-extract-plugin
export var container = "recipe-simple-header-module--container--p98gq";
export var counter = "recipe-simple-header-module--counter--TYFfx";
export var counterBox = "recipe-simple-header-module--counter-box--dHIKT";
export var counterLabel = "recipe-simple-header-module--counter-label--hSQn2";
export var link = "recipe-simple-header-module--link--zbHOs";
export var title = "recipe-simple-header-module--title--iTAw+";